import { render, staticRenderFns } from "./SkipEntranceTestDialog.vue?vue&type=template&id=5c4dc1c8&scoped=true"
import script from "./SkipEntranceTestDialog.vue?vue&type=script&lang=js"
export * from "./SkipEntranceTestDialog.vue?vue&type=script&lang=js"
import style0 from "./entrance/entrance-dialog.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SkipEntranceTestDialog.vue?vue&type=style&index=1&id=5c4dc1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4dc1c8",
  null
  
)

export default component.exports